export const INTERNAL_SERVER_ERROR = "Something went wrong. Try again"